/**
 * Holds Global state variables
 */
export default () => ({
  loading: false,
});
